
import BaseComponent from 'foundation/base-component';

export default class ImageGallery extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.total = this.refs.slides.length;
        this.setImage(0);

        this.refs.prev.addEventListener('click', () => {
            this.setImage(((this.current - 1) + this.total) % this.total);
        });

        this.refs.next.addEventListener('click', () => {
            this.setImage(((this.current + 1)) % this.total);
        });
    }

    static getRequiredRefs() {
        return ['slides'];
    }

    setImage(current) {
        this.current = current;

        this.refs.slides.forEach((slide, index) => {
            if (this.current === index) {
                slide.classList.add('is-active');
            } else {
                slide.classList.remove('is-active');
            }
        });

        const labelCurrent = this.current < 9 ? ('0' + (this.current + 1)) : (this.current + 1).toString();
        const labelTotal = this.total < 10 ? ('0' + this.total) : this.total.toString();

        this.refs.counter.innerHTML = labelCurrent + '&nbsp;/&nbsp;' + labelTotal;
    }
}
